import React from 'react';
import {useAppSelector} from "../../../../hooks/redux";
import {getBasicModules} from "../../../../store/selectors/ModulesSelectors";
import BasicModulesTitle from "./BasicModulesTitle/BasicModulesTitle";
import BasicModulesItem from "./BasicModulesItem/BasicModulesItem";
import ModuleItemsWrapper from "../../Components/ModuleItemsWrapper/ModuleItemsWrapper";

const BasicModules = () => {

    const basicModules = useAppSelector(getBasicModules)

    return (
        <div>

            {/* <BasicModulesTitle/> */}

            <ModuleItemsWrapper>
                {basicModules.map(module => <BasicModulesItem
                    key={`basicModule_${module.id}`}
                    id={module.id}
                    type={module.type}
                    title={module.title}
                    description={module.description}
                    images={module.images}
                    order={module.order}/>)}
            </ModuleItemsWrapper>

        </div>
    );
};

export default BasicModules;